export default {
  name: '张三',
  position: 'Web前端工程师',
  avatar: 'https://img.cdn.sugarat.top/mdImg/MTYxMzMwNTIyNzkyNA==613305227924',
  left: [
    {
      title: '基本资料',
      introduce: [
        '电话：12345678910',
        '邮箱：engineerzjl@foxmail.com',
        '学校：五道口职业技术学院（本科）',
        '专业：计算机科学与技术',
        ['Github：', { type: 'a', href: 'https://github.com/ATQQ', text: 'ATQQ' }],
        ['掘金：', { type: 'a', href: 'https://juejin.cn/user/1028798615918983', text: '粥里有勺糖' }],
      ],
    },
    {
      title: '专业技能',
      introduce: [
        '前端：Vue、uni-app、小程序',
        '服务端：egg.js，express，了解koa',
        '数据库：MySql，MongoDB，Redis',
        '其它：Git，PS，AE',
      ],
    },
    {
      title: '奖项荣誉',
      introduce: [
        '2020年02月 国家奖学金',
        '2020年11月 国家励志奖学金',
        '2020年02月 XX大赛一等奖',
      ],
    },
    {
      title: '自我评价',
      introduce: [
        '2年前端学习与开发经验',
        '熟悉小程序，h5开发，有上线产品开发经验',
        '阅读过Vue源码，了解其核心原理',
        '有多人项目合作开发经验，良好的跨职能沟通能力',
      ],
    },
  ],
  right: [
    {
      title: '校园经历',
      introduce: [
        {
          ordinary: [
            '2018.09 – 2022.06',
            ['五道口职业技术学院', '硕士', '计算机科学与技术'],
          ],
          dot: [
            '担任(加入)xx实验室/团队 （职称），负责了实验室门户网站的维护，带领团队成员参加了xx大赛，获得xx荣誉',
            '担任xxx，负责了xxx工作，收获了XX技能（如Adobe系列）',
          ],
        },
        {
          ordinary: [
            '2015.09 – 2019.06',
            ['五道口职业技术学院', '本科', '软件工程'],
          ],
          dot: [
            '担任(加入)xx实验室/团队 （职称），负责了实验室门户网站的维护，带领团队成员参加了xx大赛，获得xx荣誉',
            '担任xxx，负责了xxx工作，收获了XX技能（如Adobe系列）',
          ],
        },
      ],
    },
    {
      title: '实习经历',
      introduce: [
        {
          ordinary: [
            ['美团', 'Web前端工程师', '2019.12 – 2020.3'],
          ],
          dot: [
            '参与XX项目的研发，解决了xx难题',
            '开发了xx插件/工具，解决了xx问题，提升了xx效率',
            '优化xx项目，收益xx',
          ],
        },
      ],
    },
    {
      title: '项目经验',
      introduce: [
        {
          ordinary: [
            ['项目/产品名称 - 校园二手交易平台', { type: 'a', href: 'https://github.com/ATQQ/resume', text: 'xx.yy.com' }],
          ],
          dot: [
            '现有的xx方式处理xxx情况存在xx问题',
            '负责需求分析，数据库设计，前后端开发',
            '解决了XXXXX问题，学会了xx技术，收获了xx',
            '前端部分使用Vue，服务端使用Node/TS/MySQL',
          ],
        },
        {
          ordinary: [
            ['XX产品名称', { type: 'a', href: 'https://github.com/ATQQ/resume', text: 'xx.yy.com' }],
          ],
          dot: [
            '简介：校园二手交易平台',
            '难点：图片压缩，大量图片加载，级联选择组件',
            '收获：了解了常见图片压缩方案，图片的加载优化方案',
            '技术栈：Vue/express/typescript/mysql/TS/MySQL',
          ],
        },
        {
          ordinary: [
            ['XX产品名称', { type: 'a', href: 'https://github.com/ATQQ/resume', text: 'xx.yy.com' }],
          ],
          dot: [
            '参与二手交易平台的前端建设，服务端开发，数据库设计',
            '使用跨端开发框架xx,开发了web，小程序，app等多端应用',
            '有xx特色功能',
          ],
        },
      ],
    },
  ],
}
